import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const ViewLoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: 200,
    }}
  >
    <CircularProgress />
  </div>
)

export default ViewLoadingFallback
